module.exports = __webpack_public_path__ + "img/strip_a.fe066876.jpg";